import { render } from "./VipCard.vue?vue&type=template&id=6b319902&scoped=true"
import script from "./VipCard.vue?vue&type=script&lang=js"
export * from "./VipCard.vue?vue&type=script&lang=js"

import "./VipCard.vue?vue&type=style&index=0&id=6b319902&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b319902"]])

export default __exports__